import type { CoreUserTaxProfile } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

export async function getUserTaxProfile(): Promise<CoreUserTaxProfile> {
  const response = await api.get('/api/saas/me/tax_profile')
  const { data } = deserialize<CoreUserTaxProfile>(response.data)

  return data
}
